import Color from 'color'

const revenueOptions = [
  { text: 'Under $1m', value: '00000_00001' },
  { text: '$1m - $5m', value: '00001_00005' },
  { text: '$5m - $10m', value: '00005_00010' },
  { text: '$10m - $25m', value: '00010_00025' },
  { text: '$25m - $100m', value: '00025_00100' },
  { text: '$100m - $500m', value: '00100_00500' },
  { text: '$500m+', value: '00500_99999' },
]

const employeeOptions = [
  { text: '1-10', value: '00001_00010' },
  { text: '11-50', value: '00011_00050' },
  { text: '51-200', value: '00051_00200' },
  { text: '201-500', value: '00201_00500' },
  { text: '501-1000', value: '00501_01000' },
  { text: '1001-5000', value: '01001_05000' },
  { text: '5001-10000', value: '05001_10000' },
  { text: '10,000+', value: '10000_99999' },
]

const sdgOptions = [
  {
    text: 'SDG 1 - No poverty',
    value: 'No poverty',
    color: '#eb1c2d',
    code: '1',
    isFocusArea: true,
  },
  {
    text: 'SDG 2 - Zero hunger',
    value: 'Zero hunger',
    color: '#d3a029',
    code: '2',
  },
  {
    text: 'SDG 3 - Good health and well-being',
    value: 'Good health and well-being',
    color: '#279b48',
    code: '3',
  },
  {
    text: 'SDG 4 - Quality education',
    value: 'Quality education',
    color: '#c31f33',
    code: '4',
    isFocusArea: true,
  },
  {
    text: 'SDG 5 - Gender equality',
    value: 'Gender equality',
    color: '#ef402b',
    code: '5',
    isFocusArea: true,
  },
  {
    text: 'SDG 6 - Clean water and sanitation',
    value: 'Clean water and sanitation',
    color: '#26bde2',
    code: '6',
  },
  {
    text: 'SDG 7 - Affordable and clean energy',
    value: 'Affordable and clean energy',
    color: '#fdae14',
    code: '7',
    isFocusArea: true,
  },
  {
    text: 'SDG 8 - Decent work and economic growth',
    value: 'Decent work and economic growth',
    color: '#841731',
    code: '8',
    isFocusArea: true,
  },
  {
    text: 'SDG 9 - Industry, innovation and infrastructure',
    value: 'Industry, innovation and infrastructure',
    color: '#f16121',
    code: '9',
  },
  {
    text: 'SDG 10 - Reduced inequalities',
    value: 'Reduced inequalities',
    color: '#dd1479',
    code: '10',
  },
  {
    text: 'SDG 11 - Sustainable cities and communities',
    value: 'Sustainable cities and communities',
    color: '#f89222',
    code: '11',
  },
  {
    text: 'SDG 12 - Responsible consumption and production',
    value: 'Responsible consumption and production',
    color: '#c98226',
    code: '12',
  },
  {
    text: 'SDG 13 - Climate action',
    value: 'Climate action',
    color: '#3f6b36',
    code: '13',
  },
  {
    text: 'SDG 14 - Life below water',
    value: 'Life below water',
    color: '#0072b4',
    code: '14',
  },
  {
    text: 'SDG 15 - Life on Land',
    value: 'Life on Land',
    color: '#37a740',
    code: '15',
  },
  {
    text: 'SDG 16 - Peace, justice, and strong institutions',
    value: 'Peace, justice, and strong institutions',
    color: '#004b80',
    code: '16',
  },
  {
    text: 'SDG 17 - Partnerships for the goals',
    value: 'Partnerships for the goals',
    color: '#17305d',
    code: '17',
  },
  { code: '0', name: 'Others', text: 'Others', color: '#808080' },
]

const countriesList = {
  DZA: { iso2: 'DZ', iso3: 'DZA', name: 'Algeria' },
  AGO: { iso2: 'AO', iso3: 'AGO', name: 'Angola' },
  BEN: { iso2: 'BJ', iso3: 'BEN', name: 'Benin' },
  BWA: { iso2: 'BW', iso3: 'BWA', name: 'Botswana' },
  BFA: { iso2: 'BF', iso3: 'BFA', name: 'Burkina Faso' },
  BDI: { iso2: 'BI', iso3: 'BDI', name: 'Burundi' },
  CMR: { iso2: 'CM', iso3: 'CMR', name: 'Cameroon' },
  CPV: { iso2: 'CV', iso3: 'CPV', name: 'Cape Verde' },
  CAF: { iso2: 'CF', iso3: 'CAF', name: 'Central African Republic' },
  COM: { iso2: 'KM', iso3: 'COM', name: 'Comoros' },
  COD: { iso2: 'CD', iso3: 'COD', name: 'Democratic Republic of the Congo' },
  DJI: { iso2: 'DJ', iso3: 'DJI', name: 'Djibouti' },
  EGY: { iso2: 'EG', iso3: 'EGY', name: 'Egypt' },
  GNQ: { iso2: 'GQ', iso3: 'GNQ', name: 'Equatorial Guinea' },
  ERI: { iso2: 'ER', iso3: 'ERI', name: 'Eritrea' },
  ETH: { iso2: 'ET', iso3: 'ETH', name: 'Ethiopia' },
  GAB: { iso2: 'GA', iso3: 'GAB', name: 'Gabon' },
  GMB: { iso2: 'GM', iso3: 'GMB', name: 'Gambia' },
  GHA: { iso2: 'GH', iso3: 'GHA', name: 'Ghana' },
  GIN: { iso2: 'GN', iso3: 'GIN', name: 'Guinea' },
  GNB: { iso2: 'GW', iso3: 'GNB', name: 'Guinea-Bissau' },
  CIV: { iso2: 'CI', iso3: 'CIV', name: "Côte d'Ivoire" },
  KEN: { iso2: 'KE', iso3: 'KEN', name: 'Kenya' },
  TCD: { iso2: 'TD', iso3: 'TCD', name: 'Chad' },
  LSO: { iso2: 'LS', iso3: 'LSO', name: 'Lesotho' },
  LBR: { iso2: 'LR', iso3: 'LBR', name: 'Liberia' },
  LBY: { iso2: 'LY', iso3: 'LBY', name: 'Libya' },
  MDG: { iso2: 'MG', iso3: 'MDG', name: 'Madagascar' },
  MWI: { iso2: 'MW', iso3: 'MWI', name: 'Malawi' },
  MLI: { iso2: 'ML', iso3: 'MLI', name: 'Mali' },
  MRT: { iso2: 'MR', iso3: 'MRT', name: 'Mauritania' },
  MUS: { iso2: 'MU', iso3: 'MUS', name: 'Mauritius' },
  MAR: { iso2: 'MA', iso3: 'MAR', name: 'Morocco' },
  MOZ: { iso2: 'MZ', iso3: 'MOZ', name: 'Mozambique' },
  NAM: { iso2: 'NA', iso3: 'NAM', name: 'Namibia' },
  NER: { iso2: 'NE', iso3: 'NER', name: 'Niger' },
  NGA: { iso2: 'NG', iso3: 'NGA', name: 'Nigeria' },
  COG: { iso2: 'CG', iso3: 'COG', name: 'Republic of the Congo' },
  REU: { iso2: 'RE', iso3: 'REU', name: 'Reunion' },
  RWA: { iso2: 'RW', iso3: 'RWA', name: 'Rwanda' },
  SHN: { iso2: 'SH', iso3: 'SHN', name: 'Saint Helena' },
  STP: { iso2: 'ST', iso3: 'STP', name: 'Sao Tome and Principe' },
  SEN: { iso2: 'SN', iso3: 'SEN', name: 'Senegal' },
  SYC: { iso2: 'SC', iso3: 'SYC', name: 'Seychelles' },
  SLE: { iso2: 'SL', iso3: 'SLE', name: 'Sierra Leone' },
  SOM: { iso2: 'SO', iso3: 'SOM', name: 'Somalia' },
  ZAF: { iso2: 'ZA', iso3: 'ZAF', name: 'South Africa' },
  SSD: { iso2: 'SS', iso3: 'SSD', name: 'South Sudan' },
  SDN: { iso2: 'SD', iso3: 'SDN', name: 'Sudan' },
  SWZ: { iso2: 'SZ', iso3: 'SWZ', name: 'Swaziland' },
  TZA: { iso2: 'TZ', iso3: 'TZA', name: 'Tanzania' },
  TGO: { iso2: 'TG', iso3: 'TGO', name: 'Togo' },
  TUN: { iso2: 'TN', iso3: 'TUN', name: 'Tunisia' },
  UGA: { iso2: 'UG', iso3: 'UGA', name: 'Uganda' },
  ESH: { iso2: 'EH', iso3: 'ESH', name: 'Western Sahara' },
  ZMB: { iso2: 'ZM', iso3: 'ZMB', name: 'Zambia' },
  ZWE: { iso2: 'ZW', iso3: 'ZWE', name: 'Zimbabwe' },
}

const baseCompanyColor = Color('#4C9F45')

export default {
  employeeOptions,
  revenueOptions: revenueOptions.map((item, index) => {
    return {
      ...item,
      color: baseCompanyColor.lighten((6 - index) / 7).string(),
    }
  }),
  sdgOptions: sdgOptions.map(item => ({
    ...item,
    lighterColor: Color(item.color)
      .alpha(0.2)
      .string(),
  })),
  countriesList,
}
